
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import StructureNode from "./StructureNode.vue";

@Component({
  components: {
    StructureNode
  },
  name: "ChildStructureNodes"
})
export default class ChildStructureNodes extends Vue {
  @Prop()
  nodes: any;

  @Prop()
  depth: any;
}
